export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00750.6da93eec.png";